const setupSassySocialShare = () => {
    [...document.querySelectorAll("a.heateor_sss_email")].forEach((link) =>
        link.setAttribute(
            "onclick",
            link
                .getAttribute("onclick")
                .replace(
                    /window\.open\((.+?),\s*(["'])_blank\2\s*\)(;?)$/,
                    "window.location.href = $1$3",
                ),
        ),
    );
};

export default setupSassySocialShare;
